module.exports = __webpack_public_path__ + "static/media/2.ff62ae87.jpg";